import React from 'react';
import { LucideIcon } from 'lucide-react';
interface UnifiedHeaderProps {
  title: string;
  subtitle?: string;
  icon: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
  rightContent?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}
const UnifiedHeader: React.FC<UnifiedHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  iconColor = "text-white",
  iconBgColor = "bg-luxury-pinkBright/20 border-luxury-pinkBright/30",
  rightContent,
  children,
  className
}) => {
  return <div className={`fixed top-0 right-0 z-40 bg-black/95 backdrop-blur-xl border-b border-white/10 left-0 md:left-52 lg:left-64 ${className || ''}`}>
      <div className="h-[68px] px-4 items-center grid">
        <div className="w-full flex items-center justify-between">
          {/* Left content */}
          <div className="flex items-center gap-3 justify-start">
            <div className={`p-2 rounded-lg border ${iconBgColor} flex-shrink-0`}>
              <Icon className={`h-5 w-5 ${iconColor}`} />
            </div>
            <div className="min-w-0 flex-1">
              <h1 className="text-lg font-semibold text-white truncate">
                {title}
              </h1>
              {subtitle && <p className="text-white/60 text-xs truncate">
                  {subtitle}
                </p>}
            </div>
          </div>
          
          {/* Right content */}
          {rightContent && <div className="relative">
              {rightContent}
            </div>}
        </div>
        
        {/* Additional content below (for tabs, filters, etc.) */}
        {children && <div className="mt-3 pt-2 border-t border-white/5">
            {children}
          </div>}
      </div>
    </div>;
};
export default UnifiedHeader;